import { Helmet } from 'react-helmet'

const Head = () => {
  return (
    <Helmet>
      <title>{process.env.REACT_APP_NAME}</title>
    </Helmet>
  )
}

export default Head
